import { ROLES } from 'config/organization';

export const isMediaAffiliate = (role) => role === ROLES.mediaAffiliate;
